module.exports = __webpack_public_path__ + "img/font@2x.28d8c74a.png";